/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { formatDateTime } from '../../../../../utils/dayJs/format'
import { AdminFranchise } from '../../../core/_models'

type Props = {

    franchise: AdminFranchise
}

const CreatedInCell: FC<Props> = ({ franchise }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {franchise.createdAt ? formatDateTime(franchise.createdAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { CreatedInCell }
